export const environment = {
  production: false,
  i3Access: {
    logoutUrl: '/api/logout',
    authorizationGroup: 'VUS.UserAuth',
  },
  baseUrl: 'http://localhost:4200/',
  apiUrl: 'http://localhost:4200',
  accessToken: '', // Add your access-token from local storage here for local development
  refreshToken: '',
  commonApiUrl: 'http://localhost:4200/',
};
